<template>
	<div id="wjstate" class="wjstate">
		<div style="width: 100%; height: 100%;">
			<div class="leftNav">
				<div class="wjTypeChild" :style="{ height: height + 'px' }" style="overflow-y: hidden">
					<div v-for="(item, index) in navList" :key="item.id">
						<div
							style="text-align: center"
							class="wjTypeChildItemFont"
							:class="{
								wjTypeChildItem: index != 0,
								iconActive: $route.path == item.path
							}"
						>
							<div class="icon" @click="selectIcon(index)" v-show="item.show">
								<img :src="item.icon2" v-if="$route.path == item.path" />
								<img :src="item.icon" v-else />
							</div>
							<span @click="selectIcon(index)" v-show="item.show">{{ item.label }}</span>
						</div>
					</div>
				</div>
			</div>
			<router-view
				v-show="permissionList.admin1021 || permissionList.admin1022 || permissionList.admin1023 || permissionList.admin1024 || permissionList.admin1025"
			></router-view>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			permissionList: {},
			height: 0,
			navList: [
				{
					id: '0',
					label: '成绩统计',
					icon: require('@/assets/tx/tongji.png'),
					icon2: require('@/assets/tx/tongji1.png'),
					path: '/resultStats',
					show: false
				},
				{
					id: '1',
					label: '成绩排行榜',
					icon: require('@/assets/tx/shujubaobiao.png'),
					icon2: require('@/assets/tx/shujubaobiao1.png'),
					path: '/examStats/rankingList',
					show: false
				},
				{
					id: '2',
					label: '题目正确率',
					icon: require('@/assets/tx/shujubaobiao.png'),
					icon2: require('@/assets/tx/shujubaobiao1.png'),
					path: '/topicAccuracy',
					show: false
				},
				{
					id: '3',
					label: '答案来源分析',
					icon: require('@/assets/tx/laiyuanfenxi.png'),
					icon2: require('@/assets/tx/laiyuanfenxi1.png'),
					path: '/answerSource',
					show: false
				}
			]
		};
	},
	mounted() {
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};
	},
	created() {
		this.accessPermission();
	},
	methods: {
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList);
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			console.log(permissionList);
			this.permissionList = permissionList;
			this.navList.forEach(item => {
				// 成绩统计
				if (permissionList.admin1021) {
					if (item.id == 0) {
						item.show = true;
					}
				} else {
					if (item.id == 0) {
						item.show = false;
					}
				}
				// 成绩排行榜
				if (permissionList.admin1022) {
					if (item.id == 1) {
						item.show = true;
					}
				} else {
					if (item.id == 1) {
						item.show = false;
					}
				}
				// 题目正确率
				if (permissionList.admin1023) {
					if (item.id == 2) {
						item.show = true;
					}
				} else {
					if (item.id == 2) {
						item.show = false;
					}
				}
				// 答案来源分析
				if (permissionList.admin1024) {
					if (item.id == 3) {
						item.show = true;
					}
				} else {
					if (item.id == 3) {
						item.show = false;
					}
				}
				// 成绩统计复制
				if (permissionList.admin1025) {
					if (item.id == 4) {
						item.show = true;
					}
				} else {
					if (item.id == 4) {
						item.show = false;
					}
				}
			});

			for (let i = 0; i < this.navList.length; i++) {
				if (this.navList[i].show) {
					this.selectIcon(this.navList[i].id);
					return;
				}
			}
		},
		selectIcon(index) {
			if (index == 0) {
				this.$router.push('/resultStats');
			} else if (index == 1) {
				this.$router.push({
					path: '/examStats/rankingList',
					query: {
						isBack: true
					}
				});
			} else if (index == 2) {
				this.$router.push('/topicAccuracy');
			} else if (index == 3) {
				this.$router.push('/answerSource');
			}
		}
	}
};
</script>

<style scoped lang="scss">
.activebox div i {
	color: #0080ff !important;
}
.activebox p {
	color: #0080ff;
}
.wjstate {
	width: 100%;
	/* height: 100%; */
	display: flex;
	margin-top: 62px;
}
.leftNav {
	width: 80px;
	height: 100%;
	background: #ffffff;
	position: fixed;
	border-right: 2px solid #ccc;
}
.leftNav div li {
	list-style: none;
}
.textStyle {
	font-size: 14px;
	color: #333;
}
.boxbox {
	margin: 0 auto;
	width: 60px;
	margin-top: 18px;
}
.iconStyleBox {
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.rightNav {
	width: 100%;
	height: auto;
}
.wjTypeChild {
	width: 80px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
	.wjTypeChildItemFont {
		font-size: 14px;
		cursor: pointer;
		.icon {
			margin: 0px auto;
			width: 50px;
			height: 50px;
			border-radius: 5px;
			img {
				margin-top: 12px;
			}
		}
	}
	.wjTypeChildItem {
		text-align: center;
		margin-top: 40px;
	}
	.iconActive {
		color: #0080ff;
	}

	.iconActive > .icon {
		background-color: #0080ff;
	}
}
</style>
